import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Analytics } from '@vercel/analytics/react';

// Preload critical assets
const preloadCriticalAssets = () => {
  // Preload main font
  const fontPreload = document.createElement('link');
  fontPreload.rel = 'preload';
  fontPreload.as = 'font';
  fontPreload.href = '/fonts/JetBrainsMono-Regular.woff2';
  fontPreload.type = 'font/woff2';
  fontPreload.crossOrigin = 'anonymous';
  document.head.appendChild(fontPreload);
  
  // Preload important images
  const criticalImages = [
    '/new app icons/c39261c38a777d366916f344b3d46e27_Terminal.png',
  ];
  
  criticalImages.forEach(image => {
    const imgPreload = document.createElement('link');
    imgPreload.rel = 'preload';
    imgPreload.as = 'image';
    imgPreload.href = image;
    document.head.appendChild(imgPreload);
  });
};

// Run preloading
preloadCriticalAssets();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
    <Analytics debug={process.env.NODE_ENV === 'development'} />
  </React.StrictMode>
);

// Measure performance
reportWebVitals(console.log);
